// Only HTTP(S) destinations and paths on the current site are supported.
export function normalizeLogoRedirectUrl(value: unknown): string {
  if (typeof value !== 'string') return ''
  const url = value.trim()
  if (!url || /[\\\x00-\x20\x7f]/.test(url)) return ''
  if (/^\/(?!\/)/.test(url) || /^[?#]/.test(url)) return url
  if (!/^https?:\/\//i.test(url)) return ''
  try {
    const parsed = new URL(url)
    return parsed.hostname && !parsed.username && !parsed.password ? url : ''
  } catch (error) {
    return ''
  }
}
